import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

import { PopoverPaper } from 'src/components';

import styles from './UserProfile.module.scss';
import useAuthorizationContext from 'src/providers/AuthorizationHandler/useAuthorizationContext';
import { commonVaribles } from 'src/constants/constVariables';

export const UserProfile = ({ open, handleClose, anchorEl }) => {
	const { user, logoutUser } = useAuthorizationContext();
	return (
		<PopoverPaper
			open={open}
			handleClose={handleClose}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
		>
			<div className={styles.display}>
				<div className={styles.iconContainer}>
					<PersonOutlineOutlinedIcon className={styles.personIcon} />
				</div>
				<div className={styles.details}>
					<span className={styles.name}>{user.name}</span>
					<span className={clsx(styles.email)}>{user.email}</span>
					<button
						ignoreExistingClassNames
						className={clsx(styles.logoutButton)}
						onClick={logoutUser}
					>
						<svg
							style={{ height: '80%' }}
							class="MuiSvgIcon-root"
							focusable="false"
							viewBox="0 0 24 24"
							aria-hidden="true"
						>
							<path d="M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z" />
						</svg>
						{commonVaribles.logout}
					</button>
				</div>
			</div>
		</PopoverPaper>
	);
};

UserProfile.propTypes = {
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	anchorEl: PropTypes.instanceOf(Element),
};
